const ACTIVITY_PLACE_LINK_TYPES = {
  STATE_ARRENDATE: 'STATE_ARRENDATE',
  FGNE_ARRENDATE: 'FGNE_ARRENDATE',
  SELF_OWNER: 'SELF_OWNER',
  FROM_FAMILY: 'FROM_FAMILY',
  OTHER: 'OTHER',
};

const ACTIVITY_PLACE_LINK_TYPES_ENUM = Object.keys(ACTIVITY_PLACE_LINK_TYPES);

export {
  ACTIVITY_PLACE_LINK_TYPES,
  ACTIVITY_PLACE_LINK_TYPES_ENUM,
};
